export enum pageMetaTypes {
  session='session',
  public='public',
  private='private', // if a page doesn't hvae defined is type, by default is private
}
export const dashboard = '/';
export const login = '/login';
